'use client';

import { Typography } from 'components';

import TabToggle from 'components/TabToggle';
import { BusinessIcon, TranslationIcon } from 'lib/svgs/Icons';
import { useTranslations } from 'next-intl';
import { FC, Fragment, PropsWithChildren } from 'react';
import Translators from './_components/Translators';

const LoginLayout: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const t = useTranslations();

  const tabs = [
    {
      label: (
        <>
          <BusinessIcon className="mr-1 scale-[1.2] !text-inherit" />{' '}
          {t('auth.sign_in.tabs.business')}
        </>
      )
    },
    {
      label: (
        <>
          <TranslationIcon className="scale-150 !text-inherit" />{' '}
          {t('auth.sign_in.tabs.translators')}
        </>
      )
    }
  ];

  const screens = [
    <Fragment key="business">{children}</Fragment>,
    <Translators key="translators" />
  ];

  return (
    <>
      <div className="flex flex-col">
        <Typography variant="medium7xl" className={'text-tertiary-100'}>
          {t('auth.sign_in.welcome_back')}
        </Typography>
        <Typography variant="light4" className="pt-2 text-tertiary-200">
          {t('auth.sign_in.welcome')}
        </Typography>
      </div>
      <div className="flex flex-col gap-4 px-1 pt-8">
        <TabToggle tabs={tabs} className="flex flex-1 flex-col overflow-y-auto">
          {({ selectedIndex }) => (
            <div className="flex h-full flex-1 flex-col overflow-y-scroll">
              {screens[selectedIndex]}
            </div>
          )}
        </TabToggle>
      </div>
    </>
  );
};

export default LoginLayout;
